"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = exports.convertSpecialCharactersToWords = exports.toTitleCase = exports.toSlug = exports.toCamelCase = exports.limit = exports.defaultLimitSuffix = void 0;
const slugify_1 = __importDefault(require("slugify"));
exports.defaultLimitSuffix = '...';
const limit = (string, maxLength, suffix = exports.defaultLimitSuffix) => string.length < maxLength ? string : string.substring(0, maxLength) + suffix;
exports.limit = limit;
const toCamelCase = (input) => (0, exports.convertSpecialCharactersToWords)(input)
    .replace('-', ' ')
    .replace(/([a-z]{1})([A-Z]{1})/g, '$1 $2')
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
    .trim();
exports.toCamelCase = toCamelCase;
const toSlug = (input) => (0, slugify_1.default)((0, exports.convertSpecialCharactersToWords)(input), { lower: true });
exports.toSlug = toSlug;
const toTitleCase = (input) => (0, exports.convertSpecialCharactersToWords)(input)
    .replace('-', ' ')
    .replace(/([a-z]{1})([A-Z]{1})/g, '$1 $2')
    .split(' ').map(word => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`).join(' ') // eslint-disable-line newline-per-chained-call
    .replace(/ [a-z]{1}/, letter => letter.toUpperCase())
    .replace(/[ ]{2,}/g, ' ')
    .trim();
exports.toTitleCase = toTitleCase;
const convertSpecialCharactersToWords = (input) => input
    .replace('&', 'and')
    .replace('@', 'at')
    .replace('.', 'dot');
exports.convertSpecialCharactersToWords = convertSpecialCharactersToWords;
const isUrl = (to) => {
    if (typeof to !== 'string') {
        return false;
    }
    return !!to.match(/^((ht|f)tp(s)?:\/\/|mailto:|sms:|tel:)/);
};
exports.isUrl = isUrl;
__exportStar(require("./types"), exports);
